export default __webpack_public_path__ + "static/media/arloesi.5dbe0e41.png";